import React, { useEffect, useState } from "react";
import {addService} from 'API';

const AddServiceModal = ({ open, onClose, onServiceUpdated }) => {
  const [form, setForm] = useState({
    name: "",
    time_taken: "",
    price: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  const setField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (values) => {
    const e = {};

    // Errorc Check Name
    if (!values.name.trim()) {
      e.name = "Service Name is required.";
    } 
    // Time
    const timeNum = Number(values.time_taken);
    if (values.time_taken === "" || values.time_taken === null) {
      e.time_taken = "Please enter an estimated time for service.";
    } else if (!Number.isFinite(timeNum) || timeNum <= 0) {
      e.time_taken = "Are you serious ?";
    } 

    // Starting Price
    const priceNum = Number(values.price);
    if (values.price === "" || values.price === null || !Number.isFinite(priceNum) || priceNum < 0 ) {
      e.price = "Please enter a valid price. * Must be more than 0*";
    } else if (values.price === 0 ){
        e.price = " Are you saying it is for free ?"
    }
    // Description
    if (!values.description.trim()) {
      e.description = "Please describe your service";
    } 

    return e;
  };

  useEffect(() => {
    setErrors(validate(form));
    
  }, [form]);

  
  if (!open) return null;

 
  const handleSubmit = async (e) => {
  e.preventDefault();

  const nextErrors = validate(form);
  setErrors(nextErrors);

  if (Object.keys(nextErrors).length > 0) return;

  const payload = {
    name: form.name.trim(),
    time_taken: form.time_taken,
    price: Number(form.price),
    description: form.description.trim(),
  };

  try {
    const response = await addService(payload);

    if (response) {
      console.log("Service added successfully:", response);

      // reset form
      setForm({
        name: "",
        time_taken: "",
        price: "",
        description: "",
      });

      
      onServiceUpdated(response.service);
      onClose();
    }
  } catch (error) {
    console.error("Failed to add service:", error);
    
  }
};


  const hasErrors = Object.keys(errors).length > 0;

  const FieldError = ({ name }) =>
    errors[name] ? (
      <p className="mt-1 text-sm text-red-600">{errors[name]}</p>
    ) : null;

  const inputBase =
    "mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none focus:ring-2";
  const okBorder = "border-gray-300 focus:border-blue-500 focus:ring-blue-200";
  const badBorder = "border-red-400 focus:border-red-500 focus:ring-red-200";

  const getBorder = (name) =>
    errors[name] ? badBorder : okBorder;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="relative z-10 w-[92%] max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Add Service</h2>
            <p className="mt-1 text-sm text-gray-500">
              Fill in the details to create a new service.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-lg px-2 py-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {/* Service Name */}
          <div>
            <label className="text-sm font-medium text-gray-700">
              Service Name
            </label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setField("name", e.target.value)}
              placeholder="e.g., Oil Change"
              className={`${inputBase} ${getBorder("name")}`}
            />
            <FieldError name="name" />
          </div>

          {/* Estimated Time + Starting Price */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="text-sm font-medium text-gray-700">
                Estimated Time (minutes)
              </label>
              <input
                type="number"
                min="1"
                step="1"
                value={form.time_taken}
                onChange={(e) => setField("time_taken", e.target.value)}
                placeholder="e.g., 30"
                className={`${inputBase} ${getBorder("time_taken")}`}
              />
              <FieldError name="time_taken" />
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">
                Starting Price
              </label>
              <div className="relative mt-1">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">
                  $
                </span>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={form.price}
                  onChange={(e) => setField("price", e.target.value)}
                  placeholder="e.g., 49.99"
                  className={`${inputBase} pl-7 ${getBorder("price")}`}
                />
              </div>
              <FieldError name="price" />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              rows={4}
              value={form.description}
              onChange={(e) => setField("description", e.target.value)}
              placeholder="Briefly describe what's included..."
              className={`${inputBase} resize-none ${getBorder("description")}`}
            />
            <FieldError name="description" />
          </div>

          {/* Actions */}
          <div className="flex flex-col-reverse gap-3 pt-2 sm:flex-row sm:items-center sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={hasErrors}
              className="rounded-xl bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Add Service
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddServiceModal;
